import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonWrapper } from '../global/components/layout/button-wrapper';
import { TcsmModal } from '../global/components/tcsm-modal';
import { WysiwygWithReactLink } from '../global/components/wysiwyg-with-react-link';
import { buttonStyles } from '../global/constants/theme/styles/components/buttonstyles';
import { ExternalLinkState } from '../global/models/app-context-model';
import { CicSettings } from '../pages/arc/features/cic-opt/model';
import { TcsmStates } from '../root/tcsm-model';

interface Props {
	handleClose: () => void,
}
export function OptOutModal(props: Props) {
	const { handleClose } = props;

	const settings = useSelector<TcsmStates, CicSettings>(state => state?.epiProps?.cicSettingsState?.epiContent);
	const externalLinkState = useSelector<TcsmStates, ExternalLinkState>(state => state.appContext?.externalLinkState);
	const buttonClasses = buttonStyles();



	const affirmOnClick = () => {
		handleClose();

	};

	return (

		<TcsmModal
			open={externalLinkState?.renderModal}
			handleClose={handleClose}
		>
			<h2 className='modal-content-title'>{settings?.aboutElectronicDeliveryModalTitle}</h2>
			<WysiwygWithReactLink content={settings?.aboutElectronicDeliveryModalContent} />
			<ButtonWrapper flexEnd>
				<button type='button' className={buttonClasses.primaryButton} onClick={affirmOnClick} >{settings?.aboutElectronicDeliveryModalConfirmText}</button>
			</ButtonWrapper>
		</TcsmModal>
	);
}
